import { call, takeEvery, takeLatest, delay, all, put, select } from 'redux-saga/effects'
import { fetchedDownloadDataWcWi, fetchedDownloadReconciliation, fetchedDownloadReports, fetchedDownloadDmsToRlbPost } from './actions'
import { handlError, parseError } from '../../app/serverError'
import { URL as url, getHeaderJWT } from '../../../store/path'
import axios from 'axios';
import fileDownload from 'js-file-download';
import { saveAs } from 'file-saver';


function* fetchData() {
    yield takeEvery('FETCH_DOWNLOAD_REPORTS', fetchingData)
}

function* fetchingData(action) {
    const { response, error } = yield call(fetchingDataAPI, action.payload)
    if (response) {
        // console.log(response, '---reports-response')
        yield put(fetchedDownloadReports(action.payload))
        yield call(downloadingData, response)
    }
}

function fetchingDataAPI(data) {
    return axios.post(url + '/report/dms-txns/download', data, getHeaderJWT(), { crossDomain: true, responseType: 'blob' })
        .then(response => ({ response }))
}

function downloadingData(response) {
    var xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function () {
        if (this.readyState == 4 && this.status == 200) {
            var downloadUrl = URL.createObjectURL(xhttp.response);
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            a.href = downloadUrl;
            a.download = "file.xlsx";
            a.click();
        }
    };
    xhttp.open("GET", url + '/report/dms-txns/download-file/' + response.data, true);
    xhttp.setRequestHeader('X-RLB-DMS-ACC', localStorage.getItem('acc'));
    xhttp.setRequestHeader('Authorization', `Bearer ${localStorage.getItem('user')}`);
    xhttp.responseType = "blob";
    xhttp.send();
}

//region for wc_wi data

function* fetchWcWiData() {
    yield takeEvery('FETCH_DOWNLOAD_DATA_WC_WI', fetchingWcWiData)
}

function* fetchingWcWiData(action) {
    const { response, error } = yield call(fetchingWcWiDataAPI, action.payload)
    if (response) {
        // console.log(response, '---wc-wi-response')
        yield put(fetchedDownloadDataWcWi(action.payload))
        yield call(downloadingWcWiData, response)
    }
}

function fetchingWcWiDataAPI(data) {
    return axios.post(url + '/report/dms-txns/wiwc-exception', data, getHeaderJWT(), { crossDomain: true, responseType: 'blob' })
        .then(response => ({ response }))
}

function downloadingWcWiData(response) {
    var xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function () {
        if (this.readyState == 4 && this.status == 200) {
            var downloadUrl = URL.createObjectURL(xhttp.response);
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            a.href = downloadUrl;
            a.download = "file.xlsx";
            a.click();
        }
    };
    xhttp.open("GET", url + '/report/dms-txns/download-file/' + response.data, true);
    xhttp.setRequestHeader('X-RLB-DMS-ACC', localStorage.getItem('acc'));
    xhttp.setRequestHeader('Authorization', `Bearer ${localStorage.getItem('user')}`);
    xhttp.responseType = "blob";
    xhttp.send();
}

//region for Reconciliation

function* fetchReconciliation() {
    yield takeEvery('FETCH_DOWNLOAD_RECONCILIATION', fetchingReconciliationData)
}

function* fetchingReconciliationData(action) {
    const { response, error } = yield call(fetchingReconciliationAPI, action.payload, action.payload1)
    if (response) {
        // console.log(response, '---response')
        yield put(fetchedDownloadReconciliation(action.payload))
        yield call(downloadingReconciliation, response)
    }
}

function fetchingReconciliationAPI(data, res) {
    return axios.post(url + '/upload/reax-excel/' + res, data, getHeaderJWT(), { crossDomain: true, responseType: 'blob' })
        .then(response => ({ response }))
}

function downloadingReconciliation(response) {
    var xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function () {
        if (this.readyState == 4 && this.status == 200) {
            var downloadUrl = URL.createObjectURL(xhttp.response);
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            a.href = downloadUrl;
            a.download = "file.xlsx";
            a.click();
        }
    };
    xhttp.open("GET", url + '/report/dms-txns/download-file/' + response.data, true);
    xhttp.setRequestHeader('X-RLB-DMS-ACC', localStorage.getItem('acc'));
    xhttp.setRequestHeader('Authorization', `Bearer ${localStorage.getItem('user')}`);
    xhttp.responseType = "blob";
    xhttp.send();
}

// end region 

//region for Rlb to post

function* fetchRlbToPost() {
    yield takeEvery('FETCH_DOWNLOAD_DMS_TO_RLB_POST', fetchingRlbToPostData)
}

function* fetchingRlbToPostData(action) {
    const { response, error } = yield call(fetchingRlbToPostAPI, action.payload)
    // console.log(response, '---rlb-post-response')
    if (response) {
        yield put(fetchedDownloadDmsToRlbPost(action.payload))
        yield call(downloadingRlbToPost, response)
    }
}

function fetchingRlbToPostAPI(data) {
    // console.log(data,'--------rlb-post-payload')
    return axios.post(url + '/report/dms-txns/dms2rlbpostlog', data, getHeaderJWT(), { crossDomain: true, responseType: 'blob' })
        .then(response => ({ response }))
}

function downloadingRlbToPost(response) {
    var xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function () {
        if (this.readyState == 4 && this.status == 200) {
            var downloadUrl = URL.createObjectURL(xhttp.response);
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            a.href = downloadUrl;
            a.download = "file.xlsx";
            a.click();
        }
    };
    console.log(response.data,'-------------res.data')
    xhttp.open("GET", url + '/report/dms-txns/download-file/' + response.data, true);
    xhttp.setRequestHeader('X-RLB-DMS-ACC', localStorage.getItem('acc'));
    xhttp.setRequestHeader('Authorization', `Bearer ${localStorage.getItem('user')}`);
    xhttp.responseType = "blob";
    xhttp.send();
}

//end region

const sagaErrorMessage = (error, action) => {
    console.group("Saga Error:" + action.type)
    console.log(error)
    console.groupEnd()
}

export default function* downloadReportsSaga() {
    yield all([
        fetchData(),
        fetchWcWiData(),
        fetchReconciliation(),
        fetchRlbToPost(),
    ])
}  